
<template>
  <div>

    <!-- toasts message -->
    <v-card color="grey lighten-4">   
      <v-snackbar :timeout="timeout" :color="color" :left="left" v-model="snackbar" >{{ message }}</v-snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>   
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>        
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmDelete(row_index, delete_id)">Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-dialog v-model="dialog" persistent max-width="500px">
      <!-- <v-btn color="primary" dark slot="activator" class="mb-2">New User</v-btn> -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm6 md6>
                <v-text-field label="Name" v-model="formSchema.name" :rules="[v => !!v || 'Name is required !']" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field label="Username" v-model="formSchema.user_name" :rules="[v => !!v || 'Username is required !']" required></v-text-field>
              </v-flex>

               <v-flex xs12 sm6 md6>
                <v-text-field label="Email" v-model="formSchema.email" :rules="[rules.email]" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field label="Password" v-model="formSchema.password" :rules="[v => !!v || 'Password is required !']" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>            
                <v-select
                label="User Type"
                item-text="name"
                item-value="id"
                v-model="formSchema.type_id"
                :items="typelist"    
                :rules="[v => !!v || 'User type is required !']"                         
                required
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md6 v-show="instituteShow" v-if="formSchema.type_id == 1">                          
              <v-select
              label="Institute"
              item-text="name"
              item-value="id"
              v-model="formSchema.institute_id"
              :items="instituteList"  
              @change="selectInstitute(3)"                              
              ></v-select>
              </v-flex>              

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
          <v-btn color="blue darken-1" @click.native="validateBeforeSubmit" :disabled="!valid" > Save </v-btn>

        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- *******************Edit Form********************** -->
    <!-- <v-dialog v-model="dialogEditForm" persistent max-width="500px">
      <v-btn color="primary" dark slot="activator" class="mb-2">New User</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
    
        <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
    
              <v-flex xs12 sm6 md6>
                <v-text-field label="Name" v-model="formSchema.name" :rules="[v => !!v || 'Name is required !']" required></v-text-field>
              </v-flex>
    
               <v-flex xs12 sm6 md6>
                <v-text-field label="Email" v-model="formSchema.email" :rules="[rules.email]" required></v-text-field>
              </v-flex> 
    
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
          <v-btn color="blue darken-1" @click.native="validateBeforeSubmit" :disabled="!valid" > Save </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog> -->
    <!-- *******************/Edit Form********************** -->

 <!-- :headers="headers"
 :items="items" -->

 <v-card-title>
  <h2>User List</h2>
  <v-spacer></v-spacer>
  <v-text-field
  append-icon="search"
  label="Search"
  single-line
  hide-details
  v-model="search"
  ></v-text-field>
</v-card-title>

  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="items"
    :search="search"
    :pagination.sync="pagination"
    select-all
    item-key="name"
    :loading="loading"
    class="elevation-1"
  >
    <template slot="headers" slot-scope="props">
      <tr>
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
          @click="changeSort(header.value)"
        >
          <v-icon small>arrow_upward</v-icon>
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <td class="text-xs-left">{{ props.item.name }}</td>
      <td class="text-xs-right" >{{ userTypeName(props.item.type_id) }}</td>
      <td class="text-xs-right">{{ props.item.email }}</td>      
      <!-- <td class="justify-center layout px-0">
        <v-btn icon class="mx-0" @click="editItem(props.item)">
          <v-icon color="teal">edit</v-icon>
        </v-btn>
        <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.user_id)">
          <v-icon color="pink">delete</v-icon>
        </v-btn>
      </td> -->
    </template>
  </v-data-table>


</div>
</template>

<script>
  const commonService = require('../../services/common.service');

  import {preFix} from '../../vuex/api'
  import Axios from 'axios'
  export default {
    data: () => ({

      valid: true,
      dialog: false,
      dialogEditForm:false,

      search: '',
      totalItems: 0,      
      loading: true,

      pagination: {
        sortBy: 'id',
        descending:true,
      },
      
      selected:[],
      search:'',      
      headers: [

      {
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'name'
      },
      { text: 'User Type', align: 'left', value: 'type_id' },
      { text: 'Email', value: 'email' },
      
      ],
      items: [],
      item: {           
        edit: false,               
        password: '',                     
        email: '',        
        institute_id: '',                     
        create_date: '',                     
        created_user_id: '',                     
        activation_key: '',             
        
      },
      delete_id:'',
      row_index:'',
      dialog2: false,
      snackbar: false,
      color: 'success',
      mode: '',
      timeout: 3000,
      left:'left',
      message: '',

      select: null,
      instituteList: [],

      typelist:[],

      diaTypelist:[            
        {"name":"Dia", "id":"1"},      
      ],

      insTypelist:[      
      {"name":"Institute", "id":"3"},            
      ],

      adminTypelist:[      
       /* {"name":"Dia", "id":"1"},      
        {"name":"Institute", "id":"3"},*/
        {id:1, name:'DIA'},
        {id:3, name:'Institute'},
      ],

      rules: {
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Enter valied e-mail.'
        },
       
      },
      instituteShow:true,




    }),

    computed: {
      formTitle () {
        return this.item.edit ? 'Edit User' : 'New User'
      },

      formSchema(){
        return this.$store.getters.get_USERINFO_Schema ;
      }
    },

    created () {
      //console.log(this.instituteList);
      /*var fetchUrl = preFix+'institute/GetViewData' 
      var storeTypeId = localStorage.getItem('type_id');  
      var storeInstituteId = localStorage.getItem('institute_id')    
      var root = this       
      var storeInstitute = []

      if(storeTypeId == 2)
      {
        this.instituteShow = false;
        this.typelist = this.diaTypelist      
      }
      else if(storeTypeId == 1)
      {
        this.instituteShow = true;
        this.typelist= this.insTypelist
      }
      else if(storeTypeId == 3)
      {
        this.instituteShow = true;
        this.typelist= this.adminTypelist
      }

      Axios.get(fetchUrl)
      .then(function (response) {  

        var abc = response.data.instituteList
        
        if(storeTypeId == 1){
          var i =0;          
          abc.forEach(function (getVal) {            
            if(getVal.id == storeInstituteId){
              storeInstitute.push(getVal)              
            }

          });
          root.instituteList = storeInstitute          
        }
        else
        {
          root.instituteList = response.data.instituteList
        }

      })
      .catch(function (error) {
        console.log(error);
      });*/
    },
    mounted () {
      this.getDataFromApi();
    },


    methods: {

     getDataFromApi(){  

      commonService.getAllData('user').then(res => {                                    
        this.items = res;
        this.loading = false;
      });

        /*this.loading = true                
         this.$store.dispatch('fetch_USERINFO_List').then((data) => {                      
            this.items = data;    
            this.loading = false        
          }).catch((err) => {
           console.log(err)
         })*/
      },

       changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },

      validateBeforeSubmit(e) {

        var formSchema = this.formSchema

        formSchema.created_user_id = this.$store.getters.getUserId

        var root = this

        // console.log('formSchema--',formSchema);
        // return 0;

        if (this.$refs.form.validate()) {

          if ( formSchema.id > 0 )
          {            

            commonService.updateFormData(formSchema, 'user').then(res => {
              //console.log(res);
              this.close()
              this.message ='Data updated successfully!';
              this.snackbar = true
            });
          }
          else
          {
            this.$store.dispatch('save_USERINFO',{formSchema}).then((schema) => {             
              this.close()
              this.message = 'Data saved successfully!'
              this.snackbar = true
            }).catch((err) => {
              console.log(err)
            })
          }
        }  

      },

      userTypeName(typeId){
        if(typeId == 1){
          return 'DIA'
        }
        else if(typeId == 2){
          return '--'
        }
        else if(typeId == 3){
          return 'Institute'
        }
        else return 'Type Not Found'
      },

      selectInstitute(id){
        console.log('selectInstitute-----------', ids)
      },

      editItem (item) {
        this.$store.commit('USERINFO_SET_SCHEMA',item)
        this.item.edit = true
        this.dialogEditForm = true
      },

      deleteItem (index,id) {          
        this.row_index = index;
        this.delete_id = id;
        this.dialog2 = true;
      },

      confirmDelete(row_index,id){                    
        var root = this;
        this.$store.dispatch('delete_USERINFO',{id}).then(() => {
          this.items.splice(row_index, 1)

          this.message = 'Delete successful!'       
          this.snackbar = true          
          this.dialog2 = false

        }).catch((err) => {
          console.log(err)
        });       
      },

      close () {
        this.item.edit = false
        this.dialog = false
        this.dialog2 = false
        this.dialogEditForm = false
        this.$store.commit('USERINFO_UNSET_SCHEMA')
        this.getDataFromApi();
      },


      save () {
        if (this.item.edit) {
          this.item.edit = false
        } else {
          this.items.push(this.item)
        }
        this.dialog = false
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/userinfo/userinfo_table.vue